<template>
  <Toast />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <span class="text-500 line-height-3 cursor-pointer">Inventario</span>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">Carga Inicial</span>
    </li>
  </ul>
  <div class="col-12 card">
    <div class="p-fluid formgrid grid">
      <div class="field col-12 md:col-12">
        <h3>Importar Productos | Sucursales</h3>
      </div>
      <div class="field col-12 md:col-4">
        <strong>Seleccione Sucursal:</strong>
        <Dropdown
          v-model="sucursalSelect"
          :options="sucursales"
          optionLabel="nombre"
          optionValue="id"
          placeholder="Seleccione una sucursal"
          class="p-inputtext-sm"
        />
      </div>
      <div class="field col-12 md:col-2">
        <strong>Importar Sucursales?:</strong>
        <Checkbox
          v-model="importar_sucursales"
          :binary="true"
          class="p-inputtext-sm"
          v-tooltip.top="'Importar Sucursales'"
        />
      </div>
      <div class="field col-12 md:col-6">
        <strong>Seleccione Archivo:</strong><span> (.xlsx)</span>
        <FileUpload
          id="file"
          accept=".xlsx"
          name="file[]"
          type="file"
          enctype="multipart/form-data"
          :customUpload="true"
          @uploader="onChange"
          label="Cargar Archivo"
          v-tooltip.top="'Importar Archivo Excel para Carga Inicial'"
          chooseLabel="Importar"
          class="p-button-outlined mr-2"
          :disabled="cargandoExcel"
        />
      </div>
      <div class="field col-12 md:col-9">
        <h5>Carga para Paquetes |Paquete_id|Producto_id|Cantidad|:</h5>
        <FileUpload
          id="file"
          accept=".xlsx"
          name="file[]"
          type="file"
          enctype="multipart/form-data"
          :customUpload="true"
          @uploader="onChangePaquete"
          label="Cargar Archivo"
          v-tooltip.top="'Importar Archivo Excel para Paquete'"
          chooseLabel="Importar"
          class="p-button-outlined mr-2"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SucursalService from "@/service/SucursalService";
import ProductService from "@/service/ProductService";
export default {
  data() {
    return {
      sucursales: [],
      sucursalSelect: null,
      cargandoExcel: false,
      importar_sucursales: false,
    };
  },
  sucursalService: null,
  productoService: null,
  created() {
    this.sucursalService = new SucursalService();
    this.productoService = new ProductService();
  },
  mounted() {
    this.sucursalService.getSucursalesAll().then((response) => {
      this.sucursales = response;
      this.sucursales.forEach((sucursal) => {
        this.sucursalSelect = sucursal.id;
      });
    });
  },
  methods: {
    onChange(event) {
      if (this.sucursalSelect == null) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debe seleccionar una sucursal",
          life: 3000,
        });
        return;
      }
      let archivo = event.files[0];
      let formData = new FormData();
      formData.append("miarchivo", archivo);
      formData.append("sucursal_para", this.sucursalSelect);
      formData.append("importar_sucursales", this.importar_sucursales);
      this.cargandoExcel = true;
      this.productoService.importarProductos(formData).then((response) => {
        if (response.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Éxito",
            detail: response.mensaje,
            life: 3000,
          });
          this.importar_sucursales = false;
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: response.mensaje,
            life: 3000,
          });
        }
        this.cargandoExcel = false;
      });
    },
    onChangePaquete(event) {
      let archivo = event.files[0];
      let formData = new FormData();
      formData.append("miarchivo", archivo);
      this.cargandoExcel = true;
      this.productoService.importarPaquete(formData).then((response) => {
        console.log(response);
        if (response.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Éxito",
            detail: response.mensaje,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: response.mensaje,
            life: 3000,
          });
        }
        this.cargandoExcel = false;
      });
    },
  },
};
</script>
